











































































































import { paymentRequest, TicketParams } from '@/store/interfaces/tickets';
import datesDescription from './datesDescription.vue';
import { status, risk } from '@/util/transformString/translationsDecorator';
import CreditCard from '@/components/Reusable/CreditCard.vue';
import {
  tDeviceTransactionInfo,
  tTransactionModal
} from '@/store/interfaces/transactions';
import Device from '@/components/TransactionTickets/Transfer/Detail/Device.vue';
import Transaction from '@/components/TransactionTickets/Reusable/Transaction.vue';
import { dateTime } from '@/util/filters/index';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'PaymentRequest',
  components: {
    datesDescription,
    CreditCard,
    Device,
    Transaction,
  },
  props: {
    ticket: {
      type: Object as PropType<TicketParams & { ticketable: paymentRequest }>,
      required: true,
    },
  },
  data() {
    return {
      status,
      risk,
      dateTime,
    };
  },
  computed: {
    device(): tDeviceTransactionInfo {
      return {
        device_name: this.ticket.ticketable.device_name,
        device_platform: this.ticket.ticketable.device_platform,
        device_vendor: this.ticket.ticketable.device_vendor,
        device_version: this.ticket.ticketable.device_version,
      };
    },
    getTransaction(): tTransactionModal {
      return {
        authorization_number: this.ticket.ticketable.authorization_number,
        reference_number: this.ticket.ticketable.reference_number,
        risk: this.ticket.ticketable.risk,
        status: this.ticket.ticketable.status,
        response_code: this.ticket.ticketable.response_code,
        biometrics: this.ticket.ticketable.biometrics,
        distribution: this.ticket.ticketable.distribution,
        card_last_digits: this.ticket.ticketable.card_last_digits,
        card_network: this.ticket.ticketable.card_network,
      };
    },
    url(): string | null {
      const lat = this.ticket.ticketable.latitude;
      const lon = this.ticket.ticketable.longitude;
      if (lat && lon) {
        return `https://www.google.com/maps?q=${lat},${lon}&hl=es&z=14&output=embed`;
      }
      return null;
    },
  },
});
